import React from "react"
import { Link } from "gatsby"
import styled from "styled-components/macro"
import { Icon, LogoBackground, SidebarContainer, SidebarText } from "./styled/styles"

const items = [
  { name: "Weapons", published: true },
  { name: "Primals", published: true },
  { name: "Abilities", published: true },
  { name: "Trinkets", published: true },
  { name: "Banners", published: true },
]

export default props => (
  <SidebarContainer expanded={props.expanded} theme={props.theme}>
    {/**  Logo */}
    <Link
      to={`/`}
      css={`
        @media (max-width: 960px) {
          display: none;
        }
      `}
    >
      <LogoBackground src={require("../images/Sidebar/logo.png")}></LogoBackground>
    </Link>

    {items.map((item, index) => (
      <Link
        key={index}
        to={item.published ? `/${item.name.toLowerCase()}` : `/`}
        css={`
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          opacity: ${item.name === "Soon" ? 0.5 : 1};
        `}
      >
        <Icon src={require(`../images/Sidebar/${item.name.toLowerCase()}.svg`)} />
        <SidebarText
          theme={props.theme}
          css={`
            &:nth-child(4) {
              margin-bottom: 0;
            }
            @media (max-width: 960px) {
              display: none;
            }
          `}
        >
          {item.name}
        </SidebarText>
      </Link>
    ))}
  </SidebarContainer>
)
